import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'

export const SC_DrawerContent = styled.div`
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SC_TextWrapper = styled.div`
  h5 {
    font-weight: 400;
    margin-top: 4px;
  }
`

export const SC_CodeWrapper = styled.div`
  background-color: ${E_Colors.GrayF4};
  border-radius: 24px;
  padding: 24px;
  margin: 24px 0;

  > * {
    width: 100%;
  }
`

export const SC_RestWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 12px;
  background-color: ${E_Colors.GrayF4};
  border-radius: 24px;
  padding: 16px;
  margin: 12px 0 24px;
`

export const SC_RestHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`

export const SC_CertificateIdBadge = styled.div`
  background-color: ${E_Colors.Gray66};
  color: ${E_Colors.White};
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1;
`

export const SC_RestValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${E_Colors.TextPrimary};
`

export const SC_Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
